// extracted by mini-css-extract-plugin
module.exports = {"semester-date":"styles_semester-date__yWOao"};